import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import format from "date-fns/format";
import Paginator from "../paginator/Paginator";
import { searchUsers, resetUser } from "../../actions/authAction";
import { Form, Input, Button, Icon,Popup, Container, Divider, Segment, Modal } from "semantic-ui-react";

import UserEdit from "./UserEdit";
import UserDetail from "./UserDetail";
import PassChangeByAdmin from "../auth/PassChangeByAdmin";

class UserList extends Component {
  state = {
    pageO :'',
    name : '',
    editModalOpen: false,
    passwordChangeModalOpen: false,
    form: false,
  };

  componentDidMount() {
    const values = {}
    this.props.searchUsers(values);
  }

  //^^^^^^^^^^^^^^^^^^
  handleRefresh = () => {
    const { offset, limit } = this.props;

    this.props.searchUsers(limit, offset);
  };
  //^^^^^^^^^^^^^^^
  //**********************************
  handleEditModalOpen = (id) => this.setState({ editModalOpen: true, id: id });
  handleEditModalClose = () => {
    this.setState({ editModalOpen: false });
    this.props.resetUser();
  }; //
  handleEditModalCloseSubmit = () => {
    this.handleRefresh();
    this.props.resetUser();
    this.setState({ editModalOpen: false });
  };
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  
  //^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
  handlePasswordChangeModalOpen = (id) =>
    this.setState({ passwordChangeModalOpen: true, id: id });
  handlePasswordChangeModalClose = () =>
    this.setState({ passwordChangeModalOpen: false });

  //***********************************
  renderPopupState = () => {
    if (window.innerWidth < 600) {
      return true;
    }
    if (window.innerWidth > 600) {
      return false;
    }
  };
  onSubmit = () => {
    const values = {name:this.state.name}
    this.props.searchUsers(values);
    this.setState({ form: false });
  };
  renderList = (user) => {
    const {
      userId,
      uname,
      uemail,
      uphone1,
      _id,
      passwordToken,
      userStatus,
      userType,
      //createdAt
    } = user;

    //^^^^^^^^^^^
    const renderEditButton = () => (
      <Popup
        content={"Edit"}
        disabled={this.renderPopupState()}
        trigger={
          <span
            onClick={() => this.handleEditModalOpen(_id)}
            className="icon-button"
          >
            <img
              className="yimg "
              src="/editIcon.png"
              alt=" "
              style={{
                width: "25px",
                height: "25px",
                borderRadius: "5px",
                verticalAlign: "middle",
              }}
            />
          </span>
        }
      />
    );
    //^^^^^^^^^^
    
    //^^^^^^^^^^
    const renderPasswordChangeButton = () => (
      <Popup
        content={"Change Password"}
        disabled={this.renderPopupState()}
        trigger={
      <span
        className="icon-button"
        onClick={() => this.handlePasswordChangeModalOpen(_id)}
      >
        <img
          className="yimg "
          src="/passwordIcon.png"
          alt=" "
          style={{
            width: "25px",
            height: "25px",
            borderRadius: "5px",
            verticalAlign: "middle",
          }}
        />
      </span>
       }
       />
    );
    //******************
    const classBGC = () => {
      if (
        userStatus === "inactive"  < Date.now()
      ) {
        return { backgroundColor: "#ffb3b3" };
      } else {
        return {};
      }
    };
    // **********
    return (
      <Segment key={_id} style={classBGC()}>
        <div className="flex-center mb-05">
          {renderEditButton()}
         
          {renderPasswordChangeButton()}
        </div>

        <Divider fitted />
        <div>
          {uname && (
            <div className="row">
              <div className="side">
                <b>User Name</b>
              </div>
              <div className="main">
                <b>{uname}</b>
              </div>
            </div>
          )}
        </div>
        <div>
          {userId && (
            <div className="row">
              <div className="side">
                <b>User Id</b>
              </div>
              <div className="main">
                <b>{userId}</b>
              </div>
            </div>
          )}
        </div>
        <div>
          {uemail && (
            <div className="row">
              <div className="side">
                <b>User Email</b>
              </div>
              <div className="main">
                <b>{uemail}</b>
              </div>
            </div>
          )}
        </div>
        <div>
          {uphone1 && (
            <div className="row">
              <div className="side">
                <b>User's Phone</b>
              </div>
              <div className="main">
                <b>{uphone1}</b>
              </div>
            </div>
          )}
        </div>
        

        <div>
          {userType && (
            <div className="row">
              <div className="side">
                <b>User Type</b>
              </div>
              <div className="main">
                <b>{userType}</b>
              </div>
            </div>
          )}
        </div>

        <div>
          {passwordToken && (
            <div className="row">
              <div className="side">
                <b>Last Loged in On</b>
              </div>
              <div className="main">
                <b>
                  {format(new Date(parseInt(passwordToken)), "dd-MM-yyyy")} at{" "}
                  {format(new Date(parseInt(passwordToken)), "HH:mm a")}{" "}
                </b>
              </div>
            </div>
          )}
        </div>
      </Segment>
    );
  };
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  back = () => {
    const { offset, limit } = this.props;

    if (offset === 0) {
      return;
    }

    this.props.searchUsers(limit, offset - limit);
    window.scroll(0, 0);
  };

  advance = () => {
    const { offset, limit, count } = this.props;

    if (offset + limit > count) {
      return;
    }

    this.props.searchUsers(limit, offset + limit);
    window.scroll(0, 0);
  };

  handleGoToPage = () => {
    const { limit, count } = this.props;

    const values =
      (this.props.form !== undefined && this.props.form.values) || {};
    // use Math.abs for strict equality ===  to work and safe guard against negative value from user
    if (Math.abs(this.state.pageO) === 0) {
      return;
    }

    const page =
      Math.abs(this.state.pageO * limit) > count
        ? Math.ceil(count / limit - 1)
        : Math.abs(this.state.pageO) - 1;

    this.props.searchUsers(values, limit, page * limit);
    window.scroll(0, 0);
  };

  //****************** */

  renderPaginator() {
    if (this.props.users.length) {
      return (
        <Paginator
          advance={this.advance}
          back={this.back}
          offset={this.props.offset}
          limit={this.props.limit}
          count={this.props.count}
        />
      );
    }
  }
 //** */
 hideFormDispaly = () => this.setState({ form: false });
 showFormDispaly = () => this.setState({ form: true });
 renderSearchForm = () =>
   this.state.form === true ? (
     <Segment attached>
       <div className="flex-center">
         <Form onSubmit={this.onSubmit}>
           <div >
             
               <Form.Field>
                 
                 <label>Name | Phone No.</label>
                 <Input
                   type="text"
                   placeholder="Name | Phone No."
                   name="name"
                   value={this.state.name}
                   onChange={this.onChange}
                 />
               </Form.Field>

               {/* <Form.Field inline>
                 <label>Contact Group</label>
                 <select
                   name="contactGroup"
                   value={this.state.contactGroup}
                   onChange={this.handleChange}
                 >
                   <option value="">All</option>
                   {this.contactGroupOption()}
                 </select>
               </Form.Field> */}
              <div> <Button
                 //inverted
                 color="blue"
                 type="submit"
               >
                 Search
               </Button>
               <Button
                 //inverted
                 color="teal"
                 onClick={this.hideFormDispaly}
               >
                 Cancel
               </Button>
               </div>
             
           </div>
         </Form>
       </div>
     </Segment>
   ) : (
     <div></div>
   );
 //########## RENDER ###############################
  render() {
    if ((this.props.user !== null && this.props.user.superAdmin === true)
    || (this.props.userA !== null && this.props.userA.userType === 'admin')
    ) {
      return (
        <div className="font-family-Roboto maindiv-820">
          {/* Edit Modal*/}

          <Modal
            open={this.state.editModalOpen}
            onClose={this.handleEditModalClose}
            basic
            closeOnEscape={false}
            closeOnDimmerClick={false}
            // size='small'
          >
            <Modal.Content>
              <UserEdit
               id={this.state.id}
                handleEditModalCloseSubmit={this.handleEditModalCloseSubmit}
                handleEditModalClose={this.handleEditModalClose}
              />
            </Modal.Content>
          </Modal>
          {/* detail Modal*/}
          <Modal
            open={this.state.detailModalOpen}
            onClose={this.handleDetailModalClose}
            basic
            closeOnEscape={false}
            closeOnDimmerClick={false}
            // size='small'
          >
            <Modal.Content>
              <UserDetail
                id={this.state.id}
                handleDetailModalClose={this.handleDetailModalClose}
              />
            </Modal.Content>
          </Modal>

          {/* detail Modal end*/}
          {/* password change Modal*/}
          <Modal
            open={this.state.passwordChangeModalOpen}
            onClose={this.handlePasswordChangeModalClose}
            basic
            closeOnEscape={false}
            closeOnDimmerClick={false}
            // size='small'
          >
            <Modal.Content>
              <PassChangeByAdmin
                id={this.state.id}
                handlePasswordChangeModalClose={
                  this.handlePasswordChangeModalClose
                }
              />
            </Modal.Content>
          </Modal>

          {/* password change Modal end*/}
          {/**/}
          <div className="margin-auto-H">
          <div
style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',}}
>
    
      <div
className='back-btn'
>
<Link className="color-white" to="/">
<Icon name="arrow left" />
                    </Link>


</div>
    </div>
            <div
            style={{display: 'flex',flex: '80%',justifyContent: 'center',alignItems: 'center',fontSize: "1.3rem", fontWeight: "bold", padding: "5px" }}
            >
              {/*  */}
              {this.props.count} All Users
              {/*  */}
            </div>
            <div
            style={{display: 'flex',flex: '10%',justifyContent: 'center',alignItems: 'center',fontSize: "1.3rem", fontWeight: "bold", padding: "5px" }}
            onClick= {this.showFormDispaly}
            >
              <span className="icon-button border1">
              {" "}
              <Icon name="search" />
            </span>
            </div>
          </div>
          {/**/}
{/**/}
{this.renderSearchForm()}
          {/**/}
          {this.props.users.map(this.renderList)}

          {/*  */}
          <div className="disflex-paginator card-paginator media-600">
            {this.renderPaginator()}
            <div className="disflex-paginator  ">
              <div className="font-paginator">Go To Page</div>
              <form>
                <input
                  className="inputPage"
                  placeholder="number"
                  name="pageO"
                  type="number"
                  value={this.state.pageO}
                  onChange={this.onChange}
                />
                <span className="btnNumber" onClick={this.handleGoToPage}>
                  Submit
                </span>
              </form>
            </div>
            <br />
          </div>
          {/*  */}
          <br />
          <br />
          <br />
        </div>
      );
    }
    return (
      <Container text>
        <Segment>
          <div style={{ color: "red", textAlign: "center" }}>
            <h2>You Are Not Authorised To View Users </h2>
          </div>
        </Segment>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, form }) => {
  const { limit, offset, count } = auth;

  return {
    limit,
    offset,
    count,
    form,
    userA: auth.userA,
    user: auth.user,
    users: auth.usersA,
  };
};

export default connect(mapStateToProps, { searchUsers, resetUser })(UserList);
